import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api/client'
import type { Demo } from '../shared/types'

export const useDemos = (status?: string) =>
  useQuery({ queryKey: ['demos', status ?? ''], queryFn: () => api.get<Demo[]>('/api/v1/demos', { status }) })

export function useCreateDemo() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: { account_id: string; modules?: string[]; days: number; notes?: string }) =>
      api.post<Demo>('/api/v1/demos', { modules: body.modules ?? [], ...body }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['demos'] }),
  })
}

export function useExtendDemo() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, days, reason }: { id: string; days: number; reason?: string }) =>
      api.post(`/api/v1/demos/${id}/extend`, { days, reason }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['demos'] }),
  })
}

export function useConvertDemo() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, order_id }: { id: string; order_id: string }) => api.post(`/api/v1/demos/${id}/convert`, { order_id }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['demos'] }),
  })
}

export function useCancelDemo() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason?: string }) => api.post(`/api/v1/demos/${id}/cancel`, { reason }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['demos'] }),
  })
}
